import _ from "lodash";
import {
  Metric,
  MetricValue,
  TotalsValue,
  TotalsValueItem,
} from "../interface/api/get-insights";
import { Metric2 } from "../interface/Metric2";

const isTotalsValue = (entry: MetricValue): entry is TotalsValue =>
  Array.isArray(entry.value);

export const processTotalsMetric = (
  metric: Metric | undefined,
  filterType: string
): Metric2 => {
  if (!metric) {
    return { type: "pie" } as Metric2;
  }

  const totalsValues = metric.values.filter(isTotalsValue);

  if (totalsValues.length === 0) {
    return { ...metric, values: [], type: "pie" };
  }

  const values =
    filterType === "all"
      ? totalsValues.map((entry) => ({
          label: entry.label,
          value: entry.value.reduce(
            (prev: number, curr: TotalsValueItem) => prev + curr.count,
            0
          ),
        }))
      : totalsValues
          .filter((entry) =>
            entry.value.find(
              (item: TotalsValueItem) => `${item.type}` === filterType
            )
          )
          .map((entry) => ({
            label: entry.label,
            value:
              entry.value.find(
                (item: TotalsValueItem) => `${item.type}` === filterType
              )
                ?.count ?? 0,
          }));

  return {
    description: metric.description,
    name: metric.name,
    title: metric.title,
    total: metric.total,
    values: _.orderBy(values, ["value"], ["desc"]),
    type: "pie",
  };
};

export const toPieMetric = (
  metric: Metric | undefined,
  valueFormatter?: (value: number) => number | string
): Metric2 => ({
  ...(metric || ({} as Metric)),
  type: "pie",
  valueFormatter,
});

export const toLineMetric = (metric: Metric | undefined): Metric2 => ({
  ...(metric || ({} as Metric)),
  type: "line",
});
